/* @flow */
/* eslint-disable complexity */
import * as actions from '../../ActionsConst';
import helpers from './Helpers';

const initialState = [];

const products = (state: Array<{}> = initialState, action: { type: string }) => {
  switch (action.type) {
    case actions.RECEIVE_PRODUCTS:
      return helpers.buildReceiveProductsState(state, action);

    case actions.PRODUCT_DELETE_RECEIVE:
      return helpers.buildReceiveDeleteState(state, action);

    case actions.PRODUCT_SELECT_ALL:
      return helpers.buildBulkProductSelectionState(state, true);

    case actions.PRODUCT_DESELECT_ALL:
      return helpers.buildBulkProductSelectionState(state, false);

    case actions.PRODUCT_ENABLE:
      return helpers.buildEnableOneProduct(state, action);

    case actions.PRODUCT_DISABLE:
      return helpers.buildDisableOneProduct(state, action);

    case actions.PRODUCT_UPDATE:
      return helpers.buildUpdateOneProduct(state, action);

    case actions.PRODUCTS_CLEAR:
      return helpers.buildClearProducts(state, action);

    case actions.PRODUCT_CHANGE:
      return helpers.buildChangeProduct(state, action);

    case actions.UNDO_DELETE:
      return helpers.buildUndoDelete(state, action);

    default:
      return state;
  }
};

export default products;
